import { createFileRoute, Outlet } from '@tanstack/react-router'
import { MinimalAuthLayout } from '@/components/layout/minimal-auth-layout'
import { Settings } from '@/features/settings'

export const Route = createFileRoute('/_authenticated/settings')({
  component: () => (
    <MinimalAuthLayout>
      <Settings />
    </MinimalAuthLayout>
  ),
})
